import React, { useCallback, useEffect, useRef, useState } from "react";
import { Dropdown } from "../Components";
import { CheckOption, OnChange, OnChangeHelper } from "./Question";
import { NestedDropdownProps } from "./NestedInput";

export interface MultiDropDownQuestionProps {
  options: { value: string | number | boolean; label: string }[];
  checkOptions?: CheckOption;
  onChange: OnChange;
  formState: any;
  formPath: string;
  disabled?: boolean;
  onChangeHelper?: OnChangeHelper;
  dropdownProps?: NestedDropdownProps;
}

export const MultiDropDownQuestion: React.FC<MultiDropDownQuestionProps> = ({
  formState,
  checkOptions,
  formPath,
  options,
  onChange,
  onChangeHelper,
  dropdownProps,
  disabled = false,
}) => {
  const [multiDropdownOpen, setMultiDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (disabled) {
      setMultiDropdownOpen(false);
    }
  }, [disabled]);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        multiDropdownOpen
      ) {
        setMultiDropdownOpen(false);
      }
    },
    [multiDropdownOpen]
  );
  const handleEscape = useCallback(
    (event: KeyboardEvent) => {
      if (event instanceof KeyboardEvent && event.key === "Escape" && multiDropdownOpen) {
        setMultiDropdownOpen(false);
      }
    },
    [multiDropdownOpen]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [handleClickOutside, handleEscape]);

  return (
    <div ref={dropdownRef}>
      <Dropdown
        value={disabled ? "—" : checkOptions ? checkOptions() : formState[formPath]}
        options={options}
        onChange={value => {
          onChange(value, formPath, onChangeHelper);
        }}
        {...dropdownProps}
        disabled={disabled}
        hasFilterBar={false}
        multiSelect={true}
        hideCancelOnClick={true}
        hideApplyOnClick={true}
        onToggle={(_, __, metadata) => {
          if (!multiDropdownOpen) {
            setMultiDropdownOpen(true);
          } else if (metadata.source === "click") {
            setMultiDropdownOpen(false);
          }
        }}
        show={multiDropdownOpen}
      />
    </div>
  );
};
